// ---------------------------------------------------------------------------
// Bildirim → sekme yönlendirmesi
//
// Backend bildirimlerde `related_module` alanı var, ancak eski türlerin bir
// kısmında BOŞ. Bu yüzden anahtar `related_module || notification_type`
// olarak çözülür (backend'deki unread-summary ucu da aynı COALESCE'i yapar) ve
// buradaki tablo o anahtarı sidebar sekme id'sine çevirir.
//
// Yeni bir bildirim türü eklendiğinde buraya bir satır eklemek yeterli;
// eşlenmemiş türler yalnız zil panelinde görünür, sekme rozeti üretmez.
// ---------------------------------------------------------------------------

/** Bildirim modül/tür anahtarı → Sidebar sekme id'si (MASTER_MENU.id). */
export const NOTIFICATION_TAB_MAP = {
  // related_module ile gelenler
  operasyon: 'operations',
  obt: 'obt',
  mesai: 'overtime-management',
  daily_task: 'daily-maintenance',
  revision: 'revisions',
  revision_entry: 'revisions',

  // related_module'ü boş olan eski türler (notification_type üzerinden)
  mesai_assigned: 'overtime-management',
  vekalet_assigned: 'approvals',
  temporary_assignment_assigned: 'location-tracking',
  temporary_assignment_cancelled: 'location-tracking',

  // savunmacı eşlemeler (ileride üretilebilecek anahtarlar)
  izin: 'approvals',
  leave: 'approvals',
  malzeme: 'materials',
  material: 'materials',
  faaliyet: 'activity-management',
  msg: 'messages',
  message: 'messages',
  park: 'parks',
  bakim: 'daily-maintenance',
};

/** Sekme id → çip/rozet etiketi (Sidebar etiketleriyle aynı). */
export const TAB_LABELS = {
  operations: 'Anlık Görevlendirme',
  obt: 'Operasyonel Bilgi Toplama',
  parks: 'Parklar',
  'daily-maintenance': 'Park Bakım Yönetimi',
  'location-tracking': 'Görev Alanı Yönetimi',
  'passive-areas': 'Pasif Alanlar',
  'protokol-parks': 'Protokollü Parklar',
  'activity-management': 'Faaliyet Yönetimi',
  approvals: 'İzin Yönetimi',
  revisions: 'Revize Yönetimi',
  materials: 'Malzeme Yönetimi',
  messages: 'Mesajlar',
  'overtime-management': 'Mesai Yönetimi',
};

/** Bir bildirimin modül anahtarı (backend COALESCE'i ile aynı mantık). */
export const notificationModuleKey = (notification) =>
  notification?.related_module || notification?.notification_type || notification?.type || '';

/** Bir bildirimin gideceği sekme (eşleşme yoksa null). */
export const notificationTabId = (notification) =>
  NOTIFICATION_TAB_MAP[notificationModuleKey(notification)] || null;

/**
 * `{modulAnahtari: adet}` → `{sekmeId: adet}`. Aynı sekmeye düşen birden çok
 * modül anahtarı toplanır (ör. mesai + mesai_assigned).
 */
export const groupCountsByTab = (byModule) => {
  const byTab = {};
  Object.entries(byModule || {}).forEach(([key, count]) => {
    const tabId = NOTIFICATION_TAB_MAP[key];
    if (!tabId || !count) return;
    byTab[tabId] = (byTab[tabId] || 0) + count;
  });
  return byTab;
};

/** Bir sekmeye karşılık gelen tüm modül anahtarları (okundu işaretleme için). */
export const moduleKeysForTab = (tabId) =>
  Object.entries(NOTIFICATION_TAB_MAP)
    .filter(([, mappedTab]) => mappedTab === tabId)
    .map(([key]) => key);
